import React from "react"
import PropTypes from "prop-types"
import SocialIcon from "../social-icon"
import IconButtonBase from "./icon-button-base"

/**
 * @param {Object} props
 * @param {string} props.icon Social icon name (e.g. "linkedin-in", "x-twitter")
 */
const SocialIconButton = React.forwardRef(
  ({ icon, ...props }, ref) => {
    return (
      <IconButtonBase {...props} ref={ref}>
        <SocialIcon name={icon} className="pointer-events-none" />
      </IconButtonBase>
    )
  }
)

SocialIconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  className: PropTypes.string
}

export default SocialIconButton
